export default "__VITE_ASSET__DIGbeVcS__"